import { render, staticRenderFns } from "./urunSiralama.vue?vue&type=template&id=e86a18fc&scoped=true&"
import script from "./urunSiralama.vue?vue&type=script&lang=js&"
export * from "./urunSiralama.vue?vue&type=script&lang=js&"
import style0 from "./urunSiralama.vue?vue&type=style&index=0&id=e86a18fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86a18fc",
  null
  
)

export default component.exports